import Box from '@mui/material/Box';
import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Link, useMatch, useResolvedPath } from "react-router-dom"  

export default function BrotherhoodBlurb() {
    return (
        <>
            <Box>
                <Typography variant='h4' fontFamily='Proxima Nova' gutterBottom>
                    <b><Link to="/about" style={{ textDecoration: 'none', color: '#a60202' }}>Brotherhood</Link></b>
                </Typography>
                <Typography variant='body2' fontFamily='Proxima Nova' gutterBottom>
                    Within Theta Tau, the bonds we make are integral to shaping both our experiences at Boston University and our future professional careers. Having brotherhood means enjoying lifelong connections that can provide support and celebration in life's most important moments. Our brotherhood chairs are responsible for organizing events where brothers fortify fulfilling friendships and make meaningful memories. 
                ​</Typography>
            </Box>
        </>
    );
  }